import type { DepthPointDto, DepthSeriesResponseDto } from '@/services/types';

import type { CageDepthSeries, DepthPoint, DepthSeries } from './types';

function mapPoint(dto: DepthPointDto): DepthPoint {
    return {
        time: dto.time,
        value: typeof dto.value === 'number' ? dto.value : null,
    };
}

function mapCage(dto: {
    cageId?: number;
    name?: string;
    points?: DepthPointDto[];
}): CageDepthSeries | null {
    if (typeof dto.cageId !== 'number') return null;
    return {
        cageId: dto.cageId,
        name: typeof dto.name === 'string' ? dto.name : '',
        points: (dto.points ?? []).map(mapPoint),
    };
}

export function mapDepthSeriesToDomain(dto: DepthSeriesResponseDto | undefined): DepthSeries {
    return {
        cages: (dto?.cages ?? []).flatMap((cage) => {
            const mapped = mapCage(cage);
            return mapped ? [mapped] : [];
        }),
    };
}
